import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';
import { dispatch, store } from '../store';
// ----------------------------------------------------------------------
const { user } = window.sessionStorage.getItem('connected') ? JSON.parse(window.sessionStorage.getItem('connected')) : {};

const initialState = {
  isLoading: false,
  error: null,
  groups: [],
  group: null,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },

  filters: {
    filtername: '',
    actors: null,
    allactors: true,
    staffcode: user?.code,

  },

};

const slice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.groups = [];
      state.navig = initialState.navig;

    },
    // GET Group
    getGroupSuccess(state, action) {
      const { group } = action.payload;
      state.isLoading = false;
      state.group = group;
      state.error = null;

    },
    resetGroup(state) {
      state.group = initialState.group;
      state.filters = initialState.filters;

    },
    // GET groups
    getGroupsSuccess(state, action) {
      const { filtres, navig } = action.payload;
      state.isLoading = false;
      state.groups = filtres;
      state.navig = navig;
    },

    //  SORT & FILTER groups
    sortByGroups(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER groups
    paginationGroups(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    filterGroups(state, action) {
      state.filters = action.payload;
    },
    resetGroups(state) {
      state.groups = initialState.groups;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  paginationGroups,
  filterGroups,
  resetGroups,
  resetGroup,
  hasError
} = slice.actions;

// ----------------------------------------------------------------------

export function getGroups({ usercode }) {
  const { group: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      let allactors = true;
      const actor = filters?.actors?.actorCode;
      if (typeof actor !== "undefined") {
        allactors = false;
      }

      const criteres = {
        filtername: filters.filtername,
        allactors,
        actor,
        staffcode: usercode
      };
      const response = await axios.post(API.path, {
        criteres,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.SEARCHFILTER
      });

      const { data } = response;

      if (data.filtres.length === 0)
        throw new Error('NO_RESULTS');
      dispatch(slice.actions.getGroupsSuccess(data));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGroup({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const actor = code.split('~')[1];
      const response = await axios.post(API.path, {
        action: ACTIONS.LOADFILTER,
        criteres: {
          filtercode: code,
          actorcode: actor === 'ALL' ? '' : actor
        }

      });

      const { data: { data } } = response;
      dispatch(slice.actions.getGroupSuccess({ group: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function testGroupIsValid(post) {
  const { data: { reason, statut } } = await axios.post(API.path, {
    action: ACTIONS.ISGROUPVALID,
    criteres: post
  });
  if (reason === 'ALREADY EXISTS' && statut === "NOK")
    return false;
  return true;
}



